'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemDetails } from './cart-item-details.component';
import { CartItemHeader } from './cart-item-header.component';
import { CartItemProps } from './cart-item.types';

export function CartItem(props: CartItemProps) {
  return (
    <article
      className="flex flex-col gap-2 rounded-xxl border border-gray-300 bg-gray-50 p-4"
      data-testid={DataTestIdEnum.CART_ITEM}
    >
      <CartItemHeader item={props.item} />

      <CartItemDetails {...props} />
    </article>
  );
}
